import React from 'react';
import styled from 'styled-components';
import { IconButton } from '@shapegames/web-library-quick-draw-ui/dist';

interface ArticleShareProps {
  articleTitle: string;
}

export default function ArticleShare({ articleTitle }: ArticleShareProps) {
  return (
    <div>
      <ShareArticleHeadingCss>Share article on:</ShareArticleHeadingCss>
      <ShareButtonContainerCss>
        <IconButton
          variant="neutral"
          iconName="icon-social-facebook"
          onClick={() => {
            window.open(
              `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
              '_blank',
            );
          }}
        />
        <IconButton
          variant="neutral"
          iconName="icon-social-twitter"
          onClick={() => {
            window.open(
              `https://twitter.com/intent/tweet?text=${articleTitle}&url=${window.location.href}`,
              '_blank',
            );
          }}
        />
        <IconButton
          variant="neutral"
          iconName="icon-social-linkedin"
          onClick={() => {
            window.open(
              `https://www.linkedin.com/shareArticle?url=${window.location.href}`,
              '_blank',
            );
          }}
        />
        <CopyButtonCss
          variant="neutral"
          iconName="icon-ui-copy"
          onClick={() => {
            navigator.clipboard.writeText(window.location.href);
          }}
        />
      </ShareButtonContainerCss>
    </div>
  );
}

const CopyButtonCss = styled(IconButton)`
  &:focus {
    background-color: ${p => p.theme.colors.neutral900} !important;
  }
`;

const ShareArticleHeadingCss = styled.p`
  font-size: ${p => p.theme.typography.textSm2};
  color: ${({ theme }) => theme.colors.neutral700};
  margin: 0px 0px ${p => p.theme.sizes.spacing2} 0px;
`;

const ShareButtonContainerCss = styled.div`
  display: flex;
  gap: ${p => p.theme.sizes.spacing2};
`;
